import React, { useEffect, useState } from 'react';
import {
  collection,
  getDocs,
  getDoc,
  doc,
  setDoc,
  deleteDoc,
} from 'firebase/firestore';
import { db } from '../firebase';

export default function DrinksEditor() {
  const [drinks, setDrinks] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [drinkData, setDrinkData] = useState(null);
  const [isCreatingNew, setIsCreatingNew] = useState(false);

  /* ---------- Load list of drinks ---------- */
  useEffect(() => {
    const fetchDrinks = async () => {
      const snap = await getDocs(collection(db, 'stock_shop_drinks'));
      // Each doc may or may not have a 'name' field
      setDrinks(
        snap.docs.map(d => ({
          id: d.id,
          ...d.data(),
        }))
      );
    };
    fetchDrinks();
  }, []);

  /* ---------- Load a single drink for editing ---------- */
  useEffect(() => {
    const loadDrink = async () => {
      if (!selectedId || isCreatingNew) return;
      const snap = await getDoc(doc(db, 'stock_shop_drinks', selectedId));
      if (snap.exists()) {
        const data = snap.data();
        setDrinkData({
          name: data.name || selectedId.replace(/_/g, ' '), // use saved name or prettified ID
          units: data.units ?? 0,
        });
      }
    };
    loadDrink();
  }, [selectedId, isCreatingNew]);

  const startNew = () => {
    setIsCreatingNew(true);
    setSelectedId('');
    setDrinkData({ name: '', units: 0 });
  };

  /* ---------- Save or update a drink ---------- */
  const saveDrink = async () => {
    if (!drinkData?.name.trim()) {
      alert('Drink name is required');
      return;
    }

    const prettyName = drinkData.name.trim();
    const id = prettyName.replace(/\s+/g, '_');        // safe Firestore ID

    await setDoc(doc(db, 'stock_shop_drinks', id), {
      name: prettyName,                                 // ✅ store human-readable name
      units: Number(drinkData.units) || 0,
    });

    alert(isCreatingNew ? '✅ Drink added!' : '✅ Drink updated!');
    window.location.reload();
  };

  const deleteDrink = async () => {
    if (!selectedId) return;
    if (!window.confirm(`Delete ${selectedId}?`)) return;
    await deleteDoc(doc(db, 'stock_shop_drinks', selectedId));
    alert('🗑️ Drink deleted');
    window.location.reload();
  };

  return (
    <div className="h2Align">
      <h2>🥤 Drinks Editor</h2>
      <button onClick={startNew}>➕ Add New Drink</button>
      <br /><br />

      <label>Select Drink: </label>
      <select
        value={selectedId}
        onChange={(e) => {
          setSelectedId(e.target.value);
          setIsCreatingNew(false);
          setDrinkData(null);
        }}
      >
        <option value="">-- Choose --</option>
        {drinks.map((d) => (
          <option key={d.id} value={d.id}>
            {d.name || d.id.replace(/_/g, ' ')}          {/* show nice name */}
          </option>
        ))}
      </select>

      {drinkData && (
        <div style={{ marginTop: 20 }}>
          <label>Drink Name: </label>
          <input
            type="text"
            value={drinkData.name}
            onChange={(e) =>
              setDrinkData({ ...drinkData, name: e.target.value })
            }
          />
          <br /><br />
          <label>Current Units: </label>
          <input
            type="number"
            value={drinkData.units}
            onChange={(e) =>
              setDrinkData({ ...drinkData, units: Number(e.target.value) })
            }
          />
          <br /><br />
          <button className="btn btn-primary" onClick={saveDrink}>
            💾 {isCreatingNew ? 'Save New Drink' : 'Save Changes'}
          </button>
          {!isCreatingNew && (
            <button
              className="btn btn-danger"
              style={{ marginLeft: 10 }}
              onClick={deleteDrink}
            >
              🗑️ Delete
            </button>
          )}
        </div>
      )}
    </div>
  );
}
